////
/// ============================================================================
/// COMPONENT / Smart List
/// ============================================================================
///
/// @link https://github.com/nolimits4web/swiper/issues/1322
///
/// @group components
////

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default () => {
    let contentElements = document.querySelector(".js-smartlist-content");
    let topElements = document.querySelector(".js-smartlist-top");
    let bottomElements = document.querySelector(".js-smartlist-bottom");

    if (!contentElements || !topElements || !bottomElements) {
        return;
    }

    let swiperController = "";

    let contentSwiper = new Swiper(contentElements, {
        autoHeight: true,
        allowTouchMove: false
    });

    let topSwiper = new Swiper(topElements, {
        modules: [Navigation],
        autoHeight: true,
        navigation: {
            prevEl: '.js-smartlist-top-prev',
            nextEl: '.js-smartlist-top-next',
        }
    });

    let bottomSwiper = new Swiper(bottomElements, {
        modules: [Navigation],
        autoHeight: true,
        navigation: {
            prevEl: '.js-smartlist-bottom-prev',
            nextEl: '.js-smartlist-bottom-next',
        }
    });

    topSwiper.on("slideChange", () => {
        swiperController = "top";
    });

    bottomSwiper.on("slideChange", () => {
        swiperController = "bottom";
    });

    topSwiper.on("beforeTransitionStart", (swiper) => {
        if ("top" === swiperController) {
            contentSwiper.slideTo(swiper.activeIndex);
            bottomSwiper.slideTo(swiper.activeIndex);
        }
    });

    bottomSwiper.on("beforeTransitionStart", (swiper) => {
        if ("bottom" === swiperController) {
            contentSwiper.slideTo(swiper.activeIndex);
            topSwiper.slideTo(swiper.activeIndex);
        }
    });

    topSwiper.on("slideChangeTransitionEnd", () => {
        swiperController = "";
    });

    bottomSwiper.on("slideChangeTransitionEnd", () => {
        swiperController = "";
    });
};
